<div pFocusTrap class="quote-tool-lite" lxScrollTopOnNavigate>
  <div class="quote-tool-lite__header">
    <div class="quote-tool-lite__header__container" [class.quote-tool-lite__header__container--with-back-button]="withBackButton">
      <a *ngIf="returnUrl; else logoWithoutLink" [href]="returnUrl" class="quote-tool-lite__header__container__logo"></a>
      <ng-template #logoWithoutLink>
        <div class="quote-tool-lite__header__container__logo"></div>
      </ng-template>
      <a *ngIf="withBackButton" class="quote-tool-lite__header__container__back-link" [href]="returnUrl" [lxGAClickEvent]="closeDataLayerEventName">
        <div class="quote-tool-lite__header__container__back-link__container">
          <i class="pi pi-arrow-left"></i> <span *ngIf="desktop$ | async">{{ backButtonLabel }}</span>
        </div>
      </a>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>

<lx-loading-spinner
  [message]="loadingInfo().message"
  [loading]="loadingInfo().loading"
  shadingColor="rgba(0,0,0,0.5)"
  [positionRelative]="false"
></lx-loading-spinner>

<lx-toast-notification (errorEvent)="onError()"></lx-toast-notification>
